import { testId } from 'tests/e2e/utils/test-ids.constant';
import { Icons } from 'src/shared/components/ui/icons/dynamic-icon';
import { Role } from 'src/shared/types/organisation.types';
import { FeatureFlag } from 'src/shared/constants/featureFlags.constant';

type NavigationItem = {
  icon?: Icons;
  href: string;
  title: string;
  supportOnly?: boolean;
  badge?: string;
  allowedRoles?: Role[];
  featureFlag?: FeatureFlag;
  testId?: ValueOf<typeof testId.settings.navigation>;
};

export const navigationItems: NavigationItem[] = [
  {
    icon: 'User',
    href: '/settings/account',
    title: 'Account',
    testId: testId.settings.navigation.account,
  },
  {
    icon: 'Building',
    href: '/settings/organization',
    title: 'Organization',
    testId: testId.settings.navigation.organization,
  },
  {
    icon: 'Users',
    href: '/settings/users',
    title: 'Users',
    testId: testId.settings.navigation.users,
  },
  {
    icon: 'ShieldCheck',
    href: '/settings/security',
    title: 'Security',
    allowedRoles: ['ADMIN', 'SALES'],
    testId: testId.settings.navigation.security,
  },
  {
    icon: 'Key',
    href: '/settings/apikeys',
    title: 'API keys',
    allowedRoles: ['ADMIN', 'SALES'],
    testId: testId.settings.navigation.apiKeys,
  },
  {
    icon: 'FileText',
    href: '/settings/audit-logs',
    title: 'Audit Logs',
    allowedRoles: ['ADMIN', 'SALES'],
    badge: 'new',
  },
  {
    icon: 'Lock',
    href: '/settings/sso',
    title: 'SSO',
    allowedRoles: ['ADMIN', 'SALES', 'SUPPORT'],
  },
];
